import PropTypes from 'prop-types';

/**
 * Renders one column per configured language in a dynamic CSS grid,
 * so field sets can be reused regardless of how many languages a country has.
 */
const MultiLanguageFieldGroup = ({
  languages,
  renderField,
  className,
  dataTestId
}) => {
  return (
    <div
      className={`multi-language-grid ${className}`.trim()}
      style={{'--lang-col-count': languages.length || 1}}
      data-testid={dataTestId}>
      {languages.map((lang, index) => (
        <div key={lang.code} className='multi-language-column'>
          <p className='mb-2 text-sm font-semibold text-[color:var(--color-text-secondary)]'>
            Language: {lang.title}
          </p>
          {renderField(lang, index)}
        </div>
      ))}
    </div>
  );
};

MultiLanguageFieldGroup.propTypes = {
  languages: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    })
  ).isRequired,
  renderField: PropTypes.func.isRequired,
  className: PropTypes.string,
  dataTestId: PropTypes.string
};

MultiLanguageFieldGroup.defaultProps = {
  className: '',
  dataTestId: 'multi-language-field-group'
};

export default MultiLanguageFieldGroup;
